export default __webpack_public_path__ + "static/media/Img0023.23c365ed.jpg";